import { useContext } from 'react';

import { LanguageContext } from './LanguageProvider';
import { messages } from './messages';

/** 보간 파라미터. 메시지 내 `{{필드명}}` 토큰을 해당 값으로 치환한다. */
export type TranslateParams = Record<string, string | number>;

export function useT(): (key: string, params?: TranslateParams) => string {
  const language = useContext(LanguageContext);

  return (key: string, params?: TranslateParams) => {
    const template = messages[language][key] ?? messages.ko[key] ?? key;

    if (!params) {
      return template;
    }

    // `{{name}}` 토큰을 params[name] 으로 치환. params 에 없는 토큰은 그대로 둔다.
    return template.replace(/\{\{\s*(\w+)\s*\}\}/g, (match, name) => (
      name in params ? String(params[name]) : match
    ));
  };
}
